import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Question } from 'src/app/core/models/questionnaire.model';
import { QuestionAnswer } from '../question/question.component';
import { checkEmailDomain, emailValidFormat } from 'src/app/shared/validators/email.validator';

@Component({
  selector: 'app-question-email',
  templateUrl: './question-email.component.html',
  styleUrls: ['./question-email.component.scss'],
})
export class QuestionEmailComponent implements OnInit, OnDestroy {
  @Input('question') question!: Question;
  @Output('changeAnswer') changeAnswer: EventEmitter<QuestionAnswer> =
    new EventEmitter();
  regex = '';
  isLongText = false;
  inputMode: string = 'email';
  autocomplete: string | null = null;

  email = new FormControl('', [Validators.email, emailValidFormat]);
  domainSuggestion: string | null = null;
  domainUnrecognized = false;

  private readonly validInputModes = ['none', 'text', 'decimal', 'numeric', 'tel', 'search', 'email', 'url'];

  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    const configInputMode = this.question.configuration?.inputmode;
    if (configInputMode && this.validInputModes.includes(configInputMode)) {
      this.inputMode = configInputMode;
    }
    const configAutocomplete = this.question.configuration?.autocomplete;
    if (configAutocomplete) {
      this.autocomplete = configAutocomplete;
    }

    if (this.question.answer!.value) {
      this.email.setValue(this.question.answer!.value.toString());
      this.updateDomainCheck(this.question.answer!.value.toString());
    }
    this.change();

    this.email.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
    ).subscribe(value => this.updateDomainCheck(value ?? ''));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateDomainCheck(value: string): void {
    const check = checkEmailDomain(value);
    this.domainSuggestion = check?.kind === 'suggestion' ? check.domain : null;
    this.domainUnrecognized = check?.kind === 'unrecognized';
  }

  change() {
    this.question.answer!.value = this.email.value;
    this.question.isValid = this.email.valid;

    if (this.question.answer!.value && this.regex) {
      const isValid = this.checkValidation();
      this.question.isValid = isValid;
    }

    this.changeAnswer.next({
      answer: this.question.answer!,
      question: this.question,
    });
  }

  handleConfiguration() {
    if (this.question.configuration.validate) {
      this.handleValidators();
    }
  }

  handleValidators() {
    const configuration = this.question.configuration;
    const regex = configuration.validate.regex;
    if (regex) {
      this.regex = regex;

      this.question.isValid = this.checkValidation();
    }
  }

  checkValidation(): boolean {
    let valid = true;
    valid = this.checkRegex();
    return valid;
  }

  checkRegex() {
    const regexTest = new RegExp(this.regex);
    let result = false;
    if (regexTest) {
      result = regexTest.test(this.question.answer!.value?.toString() || '');
    }
    return result;
  }
}
